import React from "react"
import { AppFunctionComponent } from "../../../types"
import { SubmenuItem, SubnavigationItem } from "../../types/menu.interface"
import MobileAccordion from "../mobile-accordion/mobile-accordion.component"
import { groupByKey } from "../../helpers/group-by-key"

interface Props {
  items: SubmenuItem[]
}

interface GroupedArray {
  groupName: string
  items: SubmenuItem[]
}

const MobileCategoryWrapper: AppFunctionComponent<Props> = ({ items }) => {
  const categories = groupByKey(
    items,
    (group: any) => group.category || ""
  ) as GroupedArray[]

  return (
    <>
      {categories.map((submenuItem: GroupedArray) =>
        submenuItem.groupName ? (
          <MobileAccordion
            key={submenuItem.groupName}
            path={"/"}
            displayName={submenuItem.groupName}
            level={2}
            isCategory={Boolean(submenuItem.groupName)}
          >
            {submenuItem.items &&
              submenuItem.items.map((submenu: SubnavigationItem) => (
                <MobileAccordion
                  key={submenu.displayName}
                  path={submenu.path}
                  displayName={submenu.displayName}
                  level={3}
                />
              ))}
          </MobileAccordion>
        ) : (
          submenuItem.items &&
          submenuItem.items.map((submenu: SubnavigationItem) => (
            <MobileAccordion
              key={submenu.displayName}
              path={submenu.path}
              displayName={submenu.displayName}
              level={2}
            />
          ))
        )
      )}
    </>
  )
}

export default MobileCategoryWrapper
